import React, { type ReactNode, useState, useEffect } from "react";
import Cookies from "js-cookie";
import get from "lodash.get";
import { COLLECTIVE_USER_DATA_COOKIE } from "reg-ui-client/dist/lib/constants";
import { type AbbaUserInfo, AbbaProvider } from "@foundation/abba-client";
import { useRegUIClient } from "@foundation/reg-ui-client";

import { useUserData } from "~components/shared/userData/useUserData";

interface UserInfoProviderProps {
    children: ReactNode;
}

/* TODO Temporary until lineup is on ^4.0.0 of reg-ui-client and ^2.0.0 of foundation/reg-ui-client and any peer dependency conflicts are resolved.
    Once that is done we can fetch directly from client.getSubscriberData() */
export const getDaysSubscribed = (): number | undefined => {
    const userDataCookie = Cookies.get(COLLECTIVE_USER_DATA_COOKIE);
    if (userDataCookie) {
        const userData = JSON.parse(userDataCookie);
        return get(userData, "subscriberData.daysSubscribed");
    }
    return undefined;
};

export const UserInfoProvider = ({ children }: UserInfoProviderProps) => {
    const { client, session } = useRegUIClient();
    const [userInfo, setUserInfo] = useState<AbbaUserInfo>({});

    useUserData();

    useEffect(() => {
        const subscriber =
            client?.isBWSubscriber() ||
            client?.isBBGSubscriber() ||
            client?.isTerminalSubscriber();

        if (subscriber === userInfo?.subscriber) {
            return;
        }

        setUserInfo({ subscriber, daysSubscribed: getDaysSubscribed() });
    }, [client, session, userInfo?.subscriber]);

    return (
        <AbbaProvider platform="pages" user={userInfo}>
            {children}
        </AbbaProvider>
    );
};
